import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TouchPointModel} from '../../../../models/touch-point.model';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'kv-promo-discount-type-detail',
  template: `
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12"> <!-- [hidden]="isLoading" -->
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button pButton type="button" class="k-generic-btn" icon="fa fa-angle-left" iconPos="left" label="Back" (click)="locationBack()"></button>
                <button pButton type="button" class="k-generic-btn" icon="fa fa-floppy-o" iconPos="left" label="{{ 'common.save' | translate }}" (click)="save()"></button>
              </div>
            </div>
          </div>
          <form *ngIf="formData" [formGroup]="formData">
            <div class="ui-g form-group master-data">
              <div [kv-form-element]="{ label: 'promotion.code', md: '6' }">
                <input type="text" pInputText formControlName="code" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.description', md: '6' }">
                <input type="text" pInputText formControlName="description" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
     `
})
export class DiscountTypeDetailComponent implements OnInit {

  @Input() discountType: TouchPointModel;
  @Input() titlePage = '';
  @Output() hide = new EventEmitter();
  @Output() saveDiscountType = new EventEmitter();
  formData: FormGroup;


  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  locationBack() {
    this.hide.emit();
  }

  save() {
    if (!this.discountType.id) {
      /*Creazione nuovo touch point*/
      this.saveDiscountType.emit({
        code: this.formData.controls['code'].value,
        description: this.formData.controls['description'].value})
    }else {
      /*Modifica touch point esistente*/
      this.saveDiscountType.emit({
        id: this.discountType.id,
        code: this.formData.controls['code'].value,
        description: this.formData.controls['description'].value})
    }
  }

  createForm() {
    this.formData = this.fb.group({
      'code': this.discountType.code,
      'description': this.discountType.description,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/discount-type/components/discountTypeDetail.component.ts